var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModerationReject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 22,
    viewBox: "0 0 22 22",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22 11c0-2.17559-.6451-4.30233-1.8538-6.11127s-2.9267-3.21884-4.9367-4.0514c-2.01-.83256385-4.2217-1.050401-6.35549-.625963-2.13379.424437-4.0938 1.472083-5.63218 3.010463s-2.586026 3.49839-3.010463 5.63218c-.424438 2.13379-.20660085 4.34549.625963 6.35549.83256 2.01 2.24246 3.728 4.0514 4.9367s3.93568 1.8538 6.11127 1.8538c2.9163-.0034 5.7123-1.1634 7.7744-3.2256 2.0622-2.0621 3.2222-4.8581 3.2256-7.7744zm-3.6667 0c-.0068 1.3049-.3659 2.5838-1.0395 3.7015l-9.99529-9.99533c1.11774-.67343 2.39658-1.03257 3.70149-1.0395 1.9442.00243 3.808.77582 5.1828 2.15056 1.3747 1.37474 2.1481 3.2386 2.1505 5.18277zm-14.66663 0c.00684-1.30493.36599-2.58379 1.0395-3.7015l9.99533 9.9953c-1.1177.6735-2.3966 1.0326-3.7015 1.0395-1.94417-.0024-3.80802-.7758-5.18277-2.1505-1.37474-1.3748-2.14813-3.2386-2.15056-5.1828z",
    fill: "#ff6565"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModerationReject);
export default __webpack_public_path__ + "static/media/moderation-reject.97161454.svg";
export { ForwardRef as ReactComponent };